import { module } from 'angular';

import { default as popupReviewName, PopupReview } from './popup-review.component';
import { default as reviewCommentName, ReviewComment } from './review-comment/review-comment.component';
import { default as reviewFormName, ReviewForm } from './review-form/review-form.component';

export default module('contact.agent.core.contact.review', [])
  .component(reviewCommentName, new ReviewComment())
  .component(reviewFormName, new ReviewForm())
  .component(popupReviewName, new PopupReview()).name;
